import { render, staticRenderFns } from "./ManualMatchDrawer.vue?vue&type=template&id=80fb034a"
import script from "./ManualMatchDrawer.vue?vue&type=script&lang=js"
export * from "./ManualMatchDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports